/**
 *
 * @type {import('@webreact/webreactor/dist/Router/types').ComponentInit[]}
 */
const components = [
    {
        file: (async () => (await (import('./components/hero'))).default),
        target: '.hero__form'
    },
    {
        file: (async () => (await (import('./components/modal'))).default),
        target: '.js--modal'
    },
    {
        file: (async () => (await (import('./components/swiper'))).default),
        target: '.swiper'
    },
]

export {
    components
}